import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, LazyLoadEvent } from 'primeng/api';
import { MyCoachService } from 'src/app/services/mycoach.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { environment } from 'src/environments/environment';
import { Table } from 'primeng/table';
import { Dropdown } from 'primeng/dropdown';
import * as moment from 'moment';
import { saveAs } from 'file-saver/src/FileSaver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-coaches',
  templateUrl: './coaches.component.html',
  styleUrls: ['./coaches.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class myCoachesComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;

  public coachList: any[] = [];
  public totalRecords: number = 0;
  public loading: boolean = true;
  public paginationOption: any[] = [10, 20, 30];
  public lastTableLazyLoadEvent: LazyLoadEvent;
  public searchBy: any[] = [];
  public searchby: any;
  public startDate: any;
  public endDate: any;
  public statuses: any[] = [];
  public errorMessage: string = '';
  public hide: boolean = false;
  public playerId: string = '';
  public downloadFlg: boolean = false;
  public defaultStatus: any;
  username: string;

  // Filter variables
  public fullName: any;
  public designationName: any;
  public mobileNumber: any;

  constructor(
    private route: ActivatedRoute,
    private messageService: MessageService,
    private router: Router,
    private myCoachService: MyCoachService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination || [10, 20, 30];
    this.playerId = this.route.snapshot.paramMap.get('playerId');

    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];

    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" }
    ];
  }

  searchFilter() {
    if (this.lastTableLazyLoadEvent) {
        this.loadCoachDetails(this.lastTableLazyLoadEvent);
    } else {
        this.loadCoachDetails({ first: 0, rows: 10 });
    }
  }

  loadCoachDetails(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    this.loading = true;

    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;

    if (this.playerId) {
      params += "&filterByPlayerId=" + this.playerId;
    }

    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }

    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    // Date filters
    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    // Column filters
    if (event.filters != undefined && event.filters["fullName"] != undefined) {
      params += "&filterByFullName=" + event.filters["fullName"].value;
    }
    if (event.filters != undefined && event.filters["designationName"] != undefined) {
      params += "&filterByDesignationName=" + event.filters["designationName"].value;
    }
    if (event.filters != undefined && event.filters["mobileNumber"] != undefined) {
      params += "&filterByMobileNumber=" + event.filters["mobileNumber"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }

    // Pagination
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    // Sorting
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = event.sortOrder == 1 ? "DESC" : "ASC";
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }

    this.myCoachService.getMyCoaches(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.coachList = data.data.items;
        this.totalRecords = data.totalCount;
        this.loading = false;
        this.username = data.data.userInfo?.name;

        if (this.downloadFlg == true) {
            this.exportExcelSheet(this.coachList);
            this.downloadFlg = false;
        }
    }, err => {
        this.errorMessage = err.error?.message;
        this.loading = false;
    });
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = null;
    this.fullName = '';
    this.designationName = '';
    this.mobileNumber = '';
    this.dt.filter('', 'fullName', 'contains');
    this.dt.filter('', 'designationName', 'contains');
    this.dt.filter('', 'mobileNumber', 'contains');
    if (this.pDropDownId) {
      this.pDropDownId.clear(null);
      this.pDropDownId.value = null;
    }
    if (this.dt) {
      this.dt.reset();
    }
  }

  addCoach() {
    this.router.navigate(['/manage/customer/user/add-mycoach/' + this.playerId]);
  }

  editCoach(id: any) {
    this.router.navigate(['/manage/customer/user/add-mycoach/' + this.playerId + '/' + id]);
  }

  deleteCoach(coach: any) {
      this.confirmationService.confirm({
          message: `
          <h4 style="margin:0;">Are you sure?</h4>
          <p style="margin-top:10px;">You want to delete this coach?</p>
          `,
          header: 'Confirm',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Confirm',
          rejectLabel: 'Cancel',
          acceptIcon: '',
          rejectIcon: '',
          accept: () => {
              var updatedata = '{"disable":true}';
              this.myCoachService.updateMyCoach(coach.id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(
                  data => {
                      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Coach Deleted', life: 3000 });
                      this.loadCoachDetails(this.lastTableLazyLoadEvent);
                  },
                  err => {
                      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'System Error. Please try again.', life: 3000 });
                  }
              );
          },
          reject: () => {
              this.loadCoachDetails(this.lastTableLazyLoadEvent);
          }
      });
  }

  changeStatus(coach: any) {
    this.confirmationService.confirm({
      message: `
        <h4 style="margin:0;">Are you sure?</h4>
        <p style="margin-top:10px;">You want to change the status?</p>
      `,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      acceptIcon: '',
      rejectIcon: '',
      accept: () => {
        let updatedata = { status: coach.status };
        this.myCoachService.updateMyCoach(coach.id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Status Updated', life: 3000 });
            this.loadCoachDetails(this.lastTableLazyLoadEvent);
          },
          err => {
            this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'Update failed', life: 3000 });
            coach.status = !coach.status;
          }
        );
      },
      reject: () => {
        coach.status = !coach.status;
        this.loadCoachDetails(this.lastTableLazyLoadEvent);
      }
    });
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
      this.downloadFlg = true;
      this.loadCoachDetails(this.lastTableLazyLoadEvent);
  }

  exportExcelSheet(coachList) {
      var propertiesRemove = ['id', 'created_at', 'createdBy', 'updatedBy', 'disable', 'updated_at', 'designationId', 'created_by', 'updated_by', 'Modification_Date'];
      let downloadList = [...coachList];
      downloadList.forEach(function (item) {
          if (item.updated_at != '') {
              item['Modification_Date'] = moment(item.updated_at).format('DD/MM/YYYY');
          }
          if (item.created_at != '') {
              item['Creation_Date'] = moment(item.created_at).format('DD/MM/YYYY');
          }
          propertiesRemove.forEach(function (prop) {
              delete item[prop];
          });
      });
      import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(downloadList);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "My-Coaches");
      });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then(FileSaver => {
          let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          let EXCEL_EXTENSION = ".xlsx";
          const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
          let filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
          saveAs(data, filename);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}